import React, {useEffect, useState} from 'react';
import {InformationButton, InformationContent} from "../style";
import {setUserInformation} from "../../../../../redux";
import {useDispatch} from "react-redux";
import {Modal} from 'react-bootstrap';
import {getData} from "../../../../../assets/scripts/GeneralFunctions";
import {MAIN_URL} from "../../../../../assets/scripts/GeneralVariables";
import {TabStatusComplete, TabStatusContent} from "../../UserInformation/Child/style";
import moment from "moment-jalaali";
import {toast} from "react-toastify";
import {Link} from "react-router-dom";

function PublicInformation(props) {

    // states
    const [modal, setModal] = useState({show_user_type: false, show_tab_status: false});
    const [inputs, setInput] = useState({
        certificate: 'بله',
        description: '',
        status: 'denied',
        status_description: ''
    });
    const [data, setData] = useState({supplier_info: {}, sheet_status: {}, status_colors: {}})
    // Redux
    const dispatch = useDispatch()

    // get list
    useEffect(async () => {
        window.scroll(0,0)
        let api_result = await getData(MAIN_URL, `supplier-management/supplier-info/${props?.user_id}`, 'get', {}, true, true);
        if (api_result?.status === 200) {
            setData({
                supplier_info: api_result?.data?.supplier_info,
                sheet_status: api_result?.data?.sheet_status,
                status_colors: api_result?.data?.status_colors
            })
            setInput(prevState => ({
                ...prevState,
                status: api_result?.data?.sheet_status?.status,
                status_description: api_result?.data?.sheet_status?.message
            }))
        }
    }, [props?.user_id]);

    // back to list
    const usersListHandler = () => {
        dispatch(setUserInformation(false))
    }
    const inputHandler = (e) => {
        setInput(prevState => ({...prevState, [e.target.name]: e.target.value}))
    }

    // tab Status
    const tabStatus = () => {
        setModal(prevState => ({...prevState, show_tab_status: true}))
    }
    const tabStatusHandler = async (e) => {
        e.preventDefault()
        setModal(prevState => ({...prevState, show_tab_status: false}))
        let formData = {};
        formData['status'] = inputs?.status;
        if (inputs?.status_description) {
            formData['message'] = inputs?.status_description;
        }
        let api_result = await getData(MAIN_URL, `supplier-management/sheet-status/${props?.user_id}/supplier_info`, 'post', formData, true, true);
        if (api_result?.status === 200) {
            setData(prevState => ({...prevState, sheet_status: api_result?.data?.sheet_status}))
            toast.success('با موفقیت ثبت شد')
        }
    }

    const closeModal = () => {
        setModal({show_user_type: false, show_tab_status: false})
    }

    let supplier_info = data?.supplier_info

    return (
        <>
            <InformationContent>
                <div className="col-12 col-sm-6 col-lg-4 mb-0">
                    <TabStatusComplete
                        style={{borderRightColor: data.status_colors?.[data?.sheet_status?.status]?.colors?.border_right}}>
                        {
                            data.status_colors?.[data?.sheet_status?.status] === 'pending' || data.status_colors?.[data?.sheet_status?.status] === 'denied' ?
                                <span style={{
                                    color: data.status_colors?.[data?.sheet_status?.status]?.colors?.color,
                                    backgroundColor: data.status_colors?.[data?.sheet_status?.status]?.colors?.background
                                }} className='icon-Iconly-Bulk-Info-Square afa-icon-tick'/> :
                                <span style={{
                                    color: data.status_colors?.[data?.sheet_status?.status]?.colors?.color,
                                    backgroundColor: data.status_colors?.[data?.sheet_status?.status]?.colors?.background
                                }} className='icon-tick afa-icon-tick'/>
                        }
                        <p className='mb-0 f-14 '>
                            <span>وضعیت : </span><span>{data.status_colors?.[data?.sheet_status?.status]?.title}</span>
                        </p>
                    </TabStatusComplete>
                </div>
                <div className="col-12 col-sm-6 col-lg-8 mb-0">
                    {
                        data?.sheet_status?.message &&
                        <TabStatusContent style={{borderRightColor: data.status_colors?.[data?.sheet_status?.status]?.colors?.border_right}}>
                            <span className="icon-Iconly-Bulk-Message afa-icon-message">
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </span>
                            <p className='mb-0 f-14'>
                                <span>پیام ادمین : </span><span>{data?.sheet_status?.message}</span>
                            </p>
                        </TabStatusContent>
                    }
                </div>
                <div dir={'rtl'}>
                    <span className='afa-title'>نام تامین کننده : </span>
                    {supplier_info?.supplier_first_name ?
                        <span className="afa-value">{supplier_info?.supplier_first_name}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>
                <div dir={'rtl'}>
                    <span className='afa-title'>نام خانوادگی تامین کننده : </span>
                    {supplier_info?.supplier_last_name ?
                        <span className="afa-value">{supplier_info?.supplier_last_name}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>
                <div dir={'rtl'}>
                    <span className='afa-title'>کد ملی : </span>
                    {supplier_info?.identification_code ?
                        <span className="afa-value">{supplier_info?.identification_code}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>
                <div dir={'rtl'}>
                    <span className='afa-title'>ماهیت : </span>
                    {supplier_info?.type ?
                        <span className="afa-value">{supplier_info?.type === 'individual' ? 'حقیقی' : 'حقوقی'}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>

                <div dir={'rtl'}>
                    <span className='afa-title'>وضعیت حقوقی : </span>
                    {supplier_info?.legal_status ? <span className="afa-value">{supplier_info?.legal_status}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>

                <div dir={'rtl'}>
                    <span className='afa-title'>نام تجاری / اختصاری : </span>
                    {supplier_info?.institute_name ?
                        <span className="afa-value">{supplier_info?.institute_name}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>

                <div dir={'rtl'}>
                    <span className='afa-title'>شماره تماس مدیرعامل : </span>
                    {supplier_info?.mobile ? <span className="afa-value">{supplier_info?.mobile}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>

                <div dir={'rtl'}>
                    <span className='afa-title'>ملیت : </span>
                    {supplier_info?.nationality ? <span className="afa-value">{supplier_info?.nationality}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>
                <div dir={'rtl'}>
                    <span className='afa-title'>کد اقتصادی : </span>
                    {supplier_info?.economical_code ?
                        <span className="afa-value">{supplier_info?.economical_code}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>
                <div dir={'rtl'}>
                    <span className='afa-title'>شماره ثبت : </span>
                    {supplier_info?.registration_number ?
                        <span className="afa-value">{supplier_info?.registration_number}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>
                <div dir={'rtl'}>
                    <span className='afa-title'>محل ثبت : </span>
                    {supplier_info?.registration_location ?
                        <span className="afa-value">{supplier_info?.registration_location}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>
                <div dir={'rtl'}>
                    <span className='afa-title'>تاریخ ثبت : </span>
                    {supplier_info?.registration_date ? <span
                            className="afa-value" dir={'rtl'}>{moment(supplier_info?.registration_date).format('jYYYY-jMM-jDD')}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>
                {supplier_info?.previous_name &&
                <div dir={'rtl'}>
                    <span className='afa-title'>نام قبلی : </span>
                    <span className="afa-value">{supplier_info?.previous_name}</span>
                </div>
                }
                <div dir={'rtl'}>
                    <span className='afa-title'>نوع مالکیت : </span>
                    {supplier_info?.ownership_type ?
                        <span className="afa-value">{supplier_info?.ownership_type}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>
                <div dir={'rtl'}>
                    <span className='afa-title'>نحوه تامین : </span>
                    {supplier_info?.supply_type ? supplier_info?.supply_type?.map((row, index) => (
                            <span className="afa-value pl-3" key={index}>{row}</span>
                        )) :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>
                <div dir={'rtl'}>
                    <span className='afa-title'>شماره شبا : </span>
                    {supplier_info?.shaba_id ? <span className="afa-value">{supplier_info?.shaba_id}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>
                {
                    supplier_info?.bank_account_id &&
                <div dir={'rtl'}>
                    <span className='afa-title'>شماره حساب : </span>
                    <span className="afa-value">{supplier_info?.bank_account_id}</span>
                </div>
                }
                <div dir={'rtl'}>
                    <span className='afa-title'>نام بانک : </span>
                    {supplier_info?.bank_name ? <span className="afa-value">{supplier_info?.bank_name}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>
                <div dir={'rtl'}>
                    <span className='afa-title'>نام صاحب اثر : </span>
                    {supplier_info?.bank_account_owner_name ? <span className="afa-value">{supplier_info?.bank_account_owner_name}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>
                <div dir={'rtl'}>
                    <span className='afa-title'>مسافت از اذرفولاد : </span>
                    {supplier_info?.distance_from_afa ? <span className="afa-value">{supplier_info?.distance_from_afa}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>
                <div dir={'rtl'}>
                    <span className='afa-title'>نام شهر : </span>
                    {supplier_info?.city_name ? <span className="afa-value">{supplier_info?.city_name}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>

                {/*End Part 1*/}

                <div className="col-12 mb-4">
                    <h6 className='afa-part-title'>اطلاعات آدرس تولید کنندگان/ سازندگان (دفتر مرکزی)</h6>
                </div>

                <div dir={'rtl'}>
                    <span className='afa-title'>شماره تلفن با پیش کد : </span>
                    {supplier_info?.office_phone ? <span className="afa-value">{supplier_info?.office_phone}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>
                <div dir={'rtl'}>
                    <span className='afa-title'>موبایل : </span>
                    {supplier_info?.office_mobile ? <span className="afa-value">{supplier_info?.office_mobile}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>
                {
                    supplier_info?.office_fax &&
                    <div dir={'rtl'}>
                        <span className='afa-title'>فکس : </span>
                        <span className="afa-value">{supplier_info?.office_fax}</span>
                    </div>
                }
                <div dir={'rtl'}>
                    <span className='afa-title'>کد پستی : </span>
                    {supplier_info?.office_postal_code ? <span className="afa-value">{supplier_info?.office_postal_code}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>
                {
                    supplier_info?.office_email &&
                    <div dir={'rtl'}>
                        <span className='afa-title'>ایمیل : </span>
                        <span className="afa-value">{supplier_info?.office_email}</span>
                    </div>
                }
                {
                    supplier_info?.office_website &&
                    <div dir={'rtl'}>
                        <span className='afa-title'>وبسایت : </span>
                        <span className="afa-value">{supplier_info?.office_website}</span>
                    </div>
                }

                <div dir={'rtl'}>
                    <span className='afa-title'>آدرس دقیق : </span>
                    {supplier_info?.office_address ? <span className="afa-value">{supplier_info?.office_address}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>

                {/*End Part 2*/}

                <div className="col-12 mb-4">
                    <h6 className='afa-part-title'>اطلاعات آدرس تولید کنندگان/ سازندگان (کارخانه/کارگاه)</h6>
                </div>

                <div dir={'rtl'}>
                    <span className='afa-title'>شماره تلفن با پیش کد : </span>
                    {supplier_info?.factory_phone ? <span className="afa-value">{supplier_info?.factory_phone}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>
                <div dir={'rtl'}>
                    <span className='afa-title'>موبایل : </span>
                    {supplier_info?.factory_mobile ? <span className="afa-value">{supplier_info?.factory_mobile}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>
                {
                    supplier_info?.factory_fax &&
                    <div dir={'rtl'}>
                        <span className='afa-title'>فکس : </span>
                        <span className="afa-value">{supplier_info?.factory_fax}</span>
                    </div>
                }
                <div dir={'rtl'}>
                    <span className='afa-title'>کد پستی : </span>
                    {supplier_info?.factory_postal_code ? <span className="afa-value">{supplier_info?.factory_postal_code}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>
                {
                    supplier_info?.factory_email &&
                    <div dir={'rtl'}>
                        <span className='afa-title'>ایمیل : </span>
                        <span className="afa-value">{supplier_info?.factory_email}</span>
                    </div>
                }
                {
                    supplier_info?.factory_website &&
                    <div dir={'rtl'}>
                        <span className='afa-title'>وبسایت : </span>
                        <span className="afa-value">{supplier_info?.factory_website}</span>
                    </div>
                }

                <div dir={'rtl'}>
                    <span className='afa-title'>آدرس دقیق : </span>
                    {supplier_info?.factory_address ? <span className="afa-value">{supplier_info?.factory_address}</span> :
                        <span className="afa-value" style={{verticalAlign: 'text-top'}}><span
                            className='icon-Info-Circle afa-info-circle'
                            title={'فیلد مورد نظر خالی است'}/></span>}
                </div>

            </InformationContent>
            <InformationButton>
                <button onClick={tabStatus}>
                    <span className='afa-information-btn-title'>اعلام وضعیت</span>
                </button>
                <Link to={'/manage-supplier'}>
                    <span className='afa-information-btn-title'>لیست تامین کنندگان</span>
                </Link>
            </InformationButton>

            <Modal style={{textAlign: 'center'}} centered={true} show={modal?.show_tab_status}
                   onHide={closeModal}>
                <Modal.Body className='p-md-4' dir='rtl'>
                    <form className="row" onSubmit={tabStatusHandler}>
                        <div className="col-12 d-flex align-items-center mb-4">
                            <span style={{marginLeft: '1rem'}}>اعلام وضعیت  : </span>
                            <div className="d-flex align-items-center">
                                <label className="afa-custom-checkbox ml-4 mb-0">
                                    تکمیل
                                    <input type="radio" value='completed'
                                           onChange={inputHandler}
                                           checked={inputs[`status`] === 'completed'}
                                           name={`status`}/>
                                    <span className="checkmark"/>
                                </label>
                                <label className="afa-custom-checkbox ml-4 mb-0">
                                    ناقص
                                    <input type="radio" value='denied'
                                           onChange={inputHandler}
                                           checked={inputs[`status`] === 'denied'}
                                           name={`status`}/>
                                    <span className="checkmark"/>
                                </label>
                            </div>
                        </div>
                        <div className="mb-3 w-100">
                            <p className='k-text-right'>توضیحات</p>
                            <textarea className='afa-textarea' placeholder='توضیحات' name="status_description" rows="2"
                                      value={inputs?.status_description} onChange={inputHandler}></textarea>
                        </div>
                        <div
                            className='col-12 w-100 d-flex align-items-center'>
                            <button type='submit' className='afa-btn-save-modal'>ذخیره</button>
                            <button type='button' onClick={closeModal}
                                    className='afa-btn-cancel-modal'>انصراف
                            </button>
                        </div>
                    </form>

                </Modal.Body>
            </Modal>
        </>
    );
}

export default PublicInformation;